const firebaseConfig = {
    apiKey: "AIzaSyBCjUr5Pn7yDBiQAoP6Hr9iCTlscMrWPQw",
    authDomain: "mustafiz-tourism-website.firebaseapp.com",
    projectId: "mustafiz-tourism-website",
    storageBucket: "mustafiz-tourism-website.appspot.com",
    messagingSenderId: "177924358770",
    appId: "1:177924358770:web:a4c0ddecb4d971b724b8eb"
};

export default firebaseConfig;